import Progress from 'antd/lib/progress'

import 'antd/lib/progress/style'

export * from 'antd/lib/progress'

export default Progress
